import { render, staticRenderFns } from "./AndroidHealthPulseChart.vue?vue&type=template&id=f4f2d7f2&scoped=true"
import script from "./AndroidHealthPulseChart.vue?vue&type=script&lang=js"
export * from "./AndroidHealthPulseChart.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthPulseChart.vue?vue&type=style&index=0&id=f4f2d7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f2d7f2",
  null
  
)

export default component.exports